import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import PortalContainer from '../PortalContainer';
import { ReactComponent as CloseSvg } from '../../assets/images/svg/close-black.svg';
import './ChooseUserContainer.scss';
import { useTranslation } from 'react-i18next';
import UserCard from './components/UserCard';
import { getUserProfile } from '../../../features/user/userSlice';

const ChooseUserContainer = ({ user, onApplyHandler, onModalCloseHandler }) => {
  const { t } = useTranslation();
  const [selectedUser, setSelectedUser] = useState(0);
  const { avatar, name, email, phone } = useSelector(getUserProfile);
  const handleModalClose = useCallback(onModalCloseHandler, [onModalCloseHandler]);

  const handleEnter = () => {
    if (selectedUser === 0) {
      handleModalClose();
    } else {
      onApplyHandler();
    }
  };

  const closeBtn = (
    <span className="Modal__close" onClick={handleModalClose}>
      <CloseSvg />
    </span>
  );

  return (
    <PortalContainer>
      <div className="ModalOverlay">
        <div className={`choose_user_container`}>
          {closeBtn}
          <div>
            <p className="choose_user_title">{t('auth.loginForm.chooseAccount')}</p>
          </div>
          <ul className="choose_user_list">
            <li>
              <UserCard
                isSelected={selectedUser === 0}
                accountName={name}
                phoneOrEmail={phone || email}
                avatarLink={avatar}
                handler={() => setSelectedUser(0)}
                isCurrent
              />
            </li>
            <li>
              <UserCard
                isSelected={selectedUser === 1}
                accountName={user.name}
                phoneOrEmail={user.phone || user.email}
                avatarLink={user.avatar}
                handler={() => setSelectedUser(1)}
              />
            </li>
          </ul>
          <button className={classNames('Btn Btn--primary')} onClick={handleEnter}>
            {t('auth.loginForm.submitBtnText')}
          </button>
        </div>
      </div>
    </PortalContainer>
  );
};

ChooseUserContainer.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    avatar: PropTypes.string
  }),
  onApplyHandler: PropTypes.func.isRequired,
  onModalCloseHandler: PropTypes.func.isRequired,
  modalClassName: PropTypes.string
};

export default ChooseUserContainer;
